export default __webpack_public_path__ + "static/media/texture-plus.ddce41f0.svg";